import { timeoutFetch } from './timeoutFetch';
import { datadogRum } from '@datadog/browser-rum';

//prettier-ignore
/* istanbul ignore next */
const objToURLParameters = (obj) => obj ? '?' + Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&") : '';

export const fetchData: any = async ({
  body,
  urlData,
  endPoint,
  token,
  method = 'get',
  onError = () => {},
  headers,
}: {
  body?: object;
  urlData?: object;
  endPoint: string;
  token: string;
  method?: 'post' | 'get';
  onError?: Function;
  headers?: object;
}) => {
  try {
    const urlPara = objToURLParameters(urlData);
    const res: any = await timeoutFetch(`${endPoint}${urlPara}`, {
      method: method,
      body: JSON.stringify(body),
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...headers
      }
    });
    return res;
  } catch (error) {
    onError(error);
    datadogRum.addError(error);
  }
};
